export default __webpack_public_path__ + "static/media/cookbook.48acf12b.png";